import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form.tsx';
import { Input } from '@/components/ui/input.tsx';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TRegisterFormSchema } from './steps.tsx';

export const ConfirmEmail = () => {
  const form = useFormContext<TRegisterFormSchema>();
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">{t('auth.confirmEmail.title')}</h2>
      <span className="block">
        {t('auth.confirmEmail.description')}{' '}
        <span className="font-bold">{form.getValues('basicDetails.email')}.</span>
      </span>
      <div className="space-y-4">
        <FormField
          control={form.control}
          name="confirmEmail.code"
          render={({ field }) => (
            <FormItem>
              <FormLabel htmlFor="code" className="text-[16px]">
                {t('auth.confirmEmail.code')}
              </FormLabel>
              <FormControl>
                <div className="relative">
                  <Input
                    {...field}
                    id="code"
                    placeholder=""
                    minLength={3}
                    className="pl-8 text-[16px]"
                  />
                  <span className="text-muted-foreground absolute top-[17px] left-[9px] text-sm leading-1">
                    PB-
                  </span>
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};
